import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 20000 });

export const fetchPopularStations = async () => {
  const { data } = await http.get('/stations/popular');
  return data.stations || [];
};

export const searchStations = async (q, limit = 10) => {
  if (!q || !q.trim()) return [];
  const { data } = await http.get('/stations/search', { params: { q, limit } });
  return data.stations || [];
};

export const fetchBoard = async (stopAreaId, mode = 'departures', count = 20, name = null) => {
  if (!stopAreaId) throw new Error('stop_area_id required');
  const encoded = encodeURIComponent(stopAreaId);
  const params = { mode, count };
  if (name) params.name = name;
  const { data } = await http.get(`/board/${encoded}`, { params });
  return data;
};

export const fetchDisruptions = async (stopAreaId) => {
  const params = stopAreaId ? { stop_area_id: stopAreaId } : {};
  const { data } = await http.get('/disruptions', { params });
  return data.disruptions || [];
};

export const fetchTrip = async (vehicleJourneyId) => {
  const { data } = await http.get(`/trip/${encodeURIComponent(vehicleJourneyId)}`);
  return data;
};

export const fetchTripPiv = (number, date) =>
  http.get(`/trip-piv/${number}/${date}`).then(r => r.data);

export const fetchCommute = async (originId, destId, count = 5, opts = {}) => {
  if (!originId || !destId) throw new Error('origin_id and dest_id required');
  const params = { origin_id: originId, dest_id: destId, count };
  if (opts.fromTime) params.from_time = opts.fromTime;
  if (opts.windowMinutes) params.window_minutes = opts.windowMinutes;
  const { data } = await http.get('/commute', { params });
  return data;
};

export const isMissingTokenError = (err) => {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail || '';
  return status === 503 && detail.toLowerCase().includes('navitia_token');
};

export default http;
